import { render, staticRenderFns } from "./AccountSlider.vue?vue&type=template&id=21c3c008&scoped=true&"
import script from "./AccountSlider.vue?vue&type=script&lang=js&"
export * from "./AccountSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c3c008",
  null
  
)

export default component.exports